import type { CustomIconName } from './custom-icons';
import type { PHOSPHOR_ICON_PATHS } from './phosphor-icons';

export type IconSize =
  'small' | 'medium' | 'large' | 'default' | number | `${number}%` | `${number}px`;

export type IconWeight = 'bold' | 'fill' | 'duotone';

type RegisteredIconName = keyof typeof PHOSPHOR_ICON_PATHS | CustomIconName;

export type IconName = {
  [Name in RegisteredIconName]: Name extends `${infer BaseName}-${IconWeight}`
    ? Name | BaseName
    : Name;
}[RegisteredIconName];

export const WEIGHT_SUFFIXES: readonly string[] = ['-bold', '-fill', '-duotone'];

/* TODO: To be decided */
export const ICON_SIZE_MAP: Record<string, string> = {
  small: '16px',
  medium: '24px',
  large: '32px',
};

export function getIconSize(size: IconSize): string | undefined {
  if (typeof size === 'number') {
    return size + 'px';
  }
  if (size === 'default') {
    return undefined;
  }
  if (typeof size === 'string' && (size.endsWith('%') || size.endsWith('px'))) {
    return size;
  }

  return ICON_SIZE_MAP[size] ?? ICON_SIZE_MAP.medium;
}
